export const selectSavedSearches = ({ savedSearches: { funder } }) => funder
export const selectSavedGiftSearches = ({ savedSearches: { gift } }) => gift
